import { Flag, Flask, Folder, Folders, Pulse, Stack, Tray } from '@phosphor-icons/react';
import { Outlet, useParams } from 'react-router-dom';
import { useAccountActionLabel, useCurrentUser, useSignOut } from '../auth/useAuth';
import { Sidebar } from '../components/Sidebar';
import styles from './AppLayout.module.css';

/**
 * App shell: fixed sidebar (240px) + scrollable content area.
 * Content area has dot grid background (from body), max-width 1080px, 32px padding.
 * The sidebar reads the current route to highlight the active nav item.
 */
export function AppLayout() {
	const { id: projectId } = useParams<{ id?: string }>();
	const user = useCurrentUser();
	const signOut = useSignOut();
	const accountActionLabel = useAccountActionLabel();

	const projectSections = projectId
		? [
				{
					title: 'Project',
					items: [
						{ label: 'Overview', href: `/projects/${projectId}`, icon: Folder },
						{ label: 'Experiments', href: `/projects/${projectId}/experiments`, icon: Flask },
						{ label: 'Flags', href: `/projects/${projectId}/flags`, icon: Flag },
						{
							label: 'Exclusion Groups',
							href: `/projects/${projectId}/exclusion-groups`,
							icon: Stack,
						},
						{ label: 'Submissions', href: `/projects/${projectId}/submissions`, icon: Tray },
						{ label: 'Events', href: `/projects/${projectId}/events`, icon: Pulse },
					],
				},
			]
		: [];

	const sections = [
		{
			title: 'Projects',
			items: [{ label: 'All Projects', href: '/projects', icon: Folders }],
		},
		...projectSections,
	];

	return (
		<div className={styles.layout}>
			<Sidebar
				sections={sections}
				userName={user?.email}
				onSignOut={signOut}
				accountActionLabel={accountActionLabel}
			/>
			<main className={styles.content}>
				<div className={styles.contentInner}>
					<Outlet />
				</div>
			</main>
		</div>
	);
}
